import React, { createContext, useState } from "react";
import all_product from "../Components/all_product"; // Certifique-se de que o caminho está correto

export const ShopContext = createContext(null);

const getDefaultCart = () => {
  let cart = {};
  for (let index = 0; index < 301; index++) {
    cart[index] = 0;
  }
  return cart;
};

const ShopContextProvider = (props) => {
  // Usamos o array de produtos importado diretamente
  const products = all_product;
  const [cartItems, setCartItems] = useState(getDefaultCart());

  const addToCart = (itemId) => {
    setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] + 1 }));
  };

  const removeFromCart = (itemId) => {
    setCartItems((prev) => ({ ...prev, [itemId]: prev[itemId] - 1 }));
  };

  const getTotalCartAmount = () => {
    let totalAmount = 0;
    for (const item in cartItems) {
      if (cartItems[item] > 0) {
        // Verifica se o id do produto (pode ser number ou string)
        let itemInfo = products.find(
          (product) => product.id === Number(item) || product.id === item
        );
        if (itemInfo) {
          totalAmount += parseFloat(itemInfo.new_price) * cartItems[item];
        }
      }
    }
    return totalAmount;
  };

  const contextValue = {
    getTotalCartAmount,
    all_product: products,
    cartItems,
    addToCart,
    removeFromCart,
  };

  return (
    <ShopContext.Provider value={contextValue}>
      {props.children}
    </ShopContext.Provider>
  );
};

export default ShopContextProvider;
